import { render } from "./InvoicesTwoComponent.vue?vue&type=template&id=776f6c9a"
import script from "./InvoicesTwoComponent.vue?vue&type=script&lang=js"
export * from "./InvoicesTwoComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__